import { createKeyedDataAsyncSlice } from 'store/createKeyedDataAsyncSlice';
import { getActivityActionsAsync } from 'API/order/activities/getActivityActionsAsync';

export const { slice: activityActionsSlice, asyncAction: getActivityActionsAsyncAction } = createKeyedDataAsyncSlice(
  'activityActionsSlice',
  getActivityActionsAsync,
  ({ orderId }) => orderId
);
